import { TextField, Modal, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import IResetPassword from "../features/User/interfaces/IResetPassword";
import { clearState, resetUserPassword } from "../features/User/UserSlice";
import CustomButton from "./CustomButton";
import "../styles/components/reset-password.scss";
import toast from "react-hot-toast";
import { useHistory } from "react-router";

const ResetPassword: React.FC = () => {
  const { id, isSuccess, isError, errorMessage, successType, isFetching } =
    useSelector((state: RootState) => state.user);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const [resetPasswordData, setResetPasswordData] = useState<IResetPassword>({
    password: "",
    confirmNewPassword: "",
    newPassword: "",
    id,
  });

  const handleSubmit = () => {
    dispatch(clearState());
    dispatch(resetUserPassword(resetPasswordData));
    setOpen(true);
    history.push("/empty");
    history.push("/me");
  };

  useEffect(() => {
    if (isSuccess && successType === "resetUserPassword") {
      toast.success("Password reset successfully.");
    }

    if (isError) {
      const errors = errorMessage[0] as any;

      if (typeof errors !== "string") {
        for (let i in errors) {
          toast.error(errors[i]);
        }
      } else if (errors === "Unauthorized") {
      } else {
        toast.error(errors);
      }
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    if (!isFetching) {
      setOpen(false);
    }
  }, [isFetching]);

  return (
    <div className="reset-password--container">
      <div id="header">Reset Password</div>
      <div className="input-fields">
        <TextField
          label="Current Password"
          required
          onChange={(e) => {
            setResetPasswordData((prev) => ({
              ...prev,
              password: e.target.value,
            }));
          }}
          type="password"
        />

        <TextField
          label="New Password"
          required
          onChange={(e) => {
            setResetPasswordData((prev) => ({
              ...prev,
              newPassword: e.target.value,
            }));
          }}
          type="password"
        />

        <TextField
          label="Confirm New Password"
          required
          onChange={(e) => {
            setResetPasswordData((prev) => ({
              ...prev,
              confirmNewPassword: e.target.value,
            }));
          }}
          type="password"
        />

        <CustomButton
          className="submit"
          variant="text"
          style={{
            backgroundColor: "white",
            border: "2px solid black",
            color: "black",
          }}
          displayText="Change Password"
          onClick={() => handleSubmit()}
        />
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="delete-habit-modal"
      >
        <div
          className="loading-icon"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress style={{ color: "white" }} />
        </div>
      </Modal>
    </div>
  );
};

export default ResetPassword;
